import { IMask } from "react-imask";

import prettyDurations, {
  DURATION_UNITS,
  timecodeToDuration,
} from "./durations";
import { CUEPOINT_TIMECODE_REGEX } from "../constants/media";

import type { MediaCuepoint, MediaCuepointAdded } from "../api/MediaAPI.types";

export function isValidTimecode(timecode: string): boolean {
  return CUEPOINT_TIMECODE_REGEX.test(timecode);
}

export const sortCuepoints = (
  cuepointList: (MediaCuepoint | MediaCuepointAdded)[],
): (MediaCuepoint | MediaCuepointAdded)[] =>
  cuepointList.sort((a, b) => {
    if (
      !a?.timecode ||
      !isValidTimecode(a.timecode) ||
      !b?.timecode ||
      !isValidTimecode(b.timecode)
    ) {
      return 0;
    }

    const timecodeToMillisecondsA = timecodeToDuration(
      a.timecode,
    ).millisecondsWithFrames;
    const timecodeToMillisecondsB = timecodeToDuration(
      b.timecode,
    ).millisecondsWithFrames;

    if (timecodeToMillisecondsA === timecodeToMillisecondsB) {
      return 0;
    }

    return timecodeToMillisecondsA < timecodeToMillisecondsB ? -1 : 1;
  });

export const findInsertCuepointIndex = (
  cuepointList: (MediaCuepoint | MediaCuepointAdded)[],
  timecode: string,
): number => {
  const index = cuepointList.findIndex(
    (cuepoint) =>
      isValidTimecode(cuepoint.timecode) &&
      isValidTimecode(timecode) &&
      timecodeToDuration(cuepoint.timecode).millisecondsWithFrames >
        timecodeToDuration(timecode).millisecondsWithFrames,
  );
  return index === -1 ? cuepointList.length : index;
};

export const maskCuepoint = "HH:MM:SS:FF";

export const blocksCuepoint = {
  HH: {
    mask: IMask.MaskedRange,
    from: 0,
    to: 99,
    maxLength: 2,
  },
  MM: {
    mask: IMask.MaskedRange,
    from: 0,
    to: 59,
    maxLength: 2,
  },
  SS: {
    mask: IMask.MaskedRange,
    from: 0,
    to: 59,
    maxLength: 2,
  },
  FF: {
    mask: IMask.MaskedRange,
    from: 0,
    to: 29,
    maxLength: 2,
  },
};

export const CUEPOINT_PRESET_MINUTES = [12, 15, 25, 30] as const;

export const NO_CUEPOINT_PRESET = "none" as const;

export function minutesToOffsetTimecode(minutes: number): string {
  return prettyDurations(minutes * 60 * 1000, {
    valueUnit: DURATION_UNITS.MILLISECONDS,
  }).timecodeDuration;
}

export function valuesMatchPreset(
  minutes: number,
  startOffset: string,
  minutesBetweenCuepoints: number | undefined,
): boolean {
  return (
    startOffset === minutesToOffsetTimecode(minutes) &&
    Number(minutesBetweenCuepoints) === minutes
  );
}
